import { render, staticRenderFns } from "./AddQuestionsToStandardisedJob.vue?vue&type=template&id=9b3779f0&scoped=true"
import script from "./AddQuestionsToStandardisedJob.vue?vue&type=script&lang=ts"
export * from "./AddQuestionsToStandardisedJob.vue?vue&type=script&lang=ts"
import style0 from "./AddQuestionsToStandardisedJob.vue?vue&type=style&index=0&id=9b3779f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3779f0",
  null
  
)

export default component.exports